<template>
  <div class="row sql-where">
    <div class="col-4">
      <select class="form-control" v-model="item.field">
        <option value="sku">SKU</option>
        <option value="type">Type</option>
        <option value="name">Name</option>
        <option value="color">Colour</option>
        <option value="w">Width</option>
        <option value="h">Height</option>
        <option value="d">Depth/thinkness</option>
      </select>
    </div>
    <div class="col-3">
      <select class="form-control" v-model="item.operator">
        <option value="=">=</option>
        <option value="like">Matches</option>
        <option value="startswith">Starts with</option>
        <option value="endswith">Ends with</option>
        <option value=">">Greater than</option>
        <option value="<">Less than</option>
      </select>
    </div>
    <div class="col-5">
      <input
        type="text"
        class="form-control"
        v-model="item.value"
        placeholder="Value or formula"
        title="Use quote marks around literal (non formula) values"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: Object,
  },
  computed: {
    item: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
</style>